module.exports = __webpack_public_path__ + "static/media/mb-oml.a1c0d7a4.png";